import img1 from './1.jpg';
import img2 from './2.jpg';
import img3 from './3.jpg';
import img5 from './5.png';
import img4 from './4.jpg';
import img6 from './6.png';
import img7 from './7.jpg';
import img9 from './9.jpg';
import img10 from './10.jpg';
import React from 'react';
import { ImageSlider } from '../../components/styles/Photos';

const array = [img1, img2, img3, img4, img5, img6, img7, img9, img10];

export default array.map((img, index) => (
  <ImageSlider>
    <img src={img} alt={index} />
  </ImageSlider>
));
